import { EVENTS_CHANNEL } from '@/constants/events';
import sendCustomEvents from '@/utils/sendCustomEvents';

const sendEvent = (eventType: string, eventData: Record<string, unknown> = {}) => {
  sendCustomEvents(EVENTS_CHANNEL, eventType, eventData);
};

export default sendEvent;
